<div class="row align-items-center">
  <div class="col pe-0">
    <ng-select
      #ngSelectRef
      [(ngModel)]="_selectedContact"
      class="ng-select-sm w-100"
      [class.is-invalid]="showValidation()"
      [class.large-contact-list]="hasLargeContactList()"
      [disabled]="disabled()"
      [items]="(contacts$ | async) || []"
      [typeahead]="searchInput$"
      [virtualScroll]="true"
      [loading]="loadingContacts()"
      bindLabel="option"
      bindValue="value"
      [clearable]="true"
      placeholder="Search or create a contact"
      [addTag]="addNewContact"
      (ngModelChange)="changeSelection()"
      (scrollToEnd)="onScrollToEnd()"
      (scroll)="onScroll($event)"
      notFoundText="No contact found.">
      <ng-template
        ng-footer-tmp
        let-searchTerm="searchTerm">
        @if (searchTerm && searchTerm.length > 0 && !isContactInList(searchTerm)) {
          <div class="p-2">
            <button
              class="add-new-contact-header btn btn-outline-primary w-100 btn-sm"
              (click)="addAndSelectNewContact(searchTerm, ngSelectRef)">
              Add new contact: <span class="ms-1">"{{ searchTerm }}"</span>
            </button>
          </div>
        }
      </ng-template>
    </ng-select>
  </div>
  @if (!disabled()) {
    <div class="col-auto">
      <button
        type="button"
        class="btn-light-on-white btn btn-sm min-w-auto"
        id="syncContacts"
        title="Fetch new contacts from your accounting software"
        (click)="syncContacts()"
        [disabled]="busySyncing()">
        @if (busySyncing()) {
          <i class="spinner-border spinner-border-sm"></i>
          @if (!isMobile()) {
            &nbsp;Syncing
          }
        } @else {
          <i class="iconoir-refresh-double"></i>
          @if (!isMobile()) {
            &nbsp;Refresh list
          }
        }
      </button>
    </div>
  }
</div>
